import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import b from 'b_';

import './outreach.stub.css';

import EventItemStub from '@components/event-item/event-item.stub';
import ProjectItemStub from '@components/project-item/project-item.stub';
import DatasetItemStub from '@components/dataset-item/dataset-item.stub';
import ContentBlock from '@components/content-block';

const class_ = b.with('outreach-stub');

export default class HomePageStub extends Component {
    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        return (
            <div className={class_()}>
                <ContentBlock
                    title="Events"
                    top={
                        <Link to="/outreach/events" className="block__title-link">
                            All Events
                        </Link>
                    }
                    content={(
                        <div className={class_('entities-wrapper')}>
                            <EventItemStub type="vertical" />
                            <EventItemStub type="vertical" />
                            <EventItemStub type="vertical" />
                        </div>
                    )}
                />
                <ContentBlock
                    title="Our Open source projects"
                    top={
                        <Link to="/outreach/projects" className="block__title-link">
                            All Open source projects
                        </Link>
                    }
                    content={(
                        <div className={class_('entities-wrapper')}>
                            <ProjectItemStub type="vertical" />
                            <ProjectItemStub type="vertical" />
                            <ProjectItemStub type="vertical" />
                        </div>
                    )}
                />
                <ContentBlock
                    title="Datasets"
                    top={
                        <Link to="/outreach/datasets" className="block__title-link">
                            All Datasets
                        </Link>
                    }
                    content={(
                        <div className={class_('entities-wrapper')}>
                            <DatasetItemStub type="vertical" />
                            <DatasetItemStub type="vertical" />
                            <DatasetItemStub type="vertical" />
                        </div>
                    )}
                />
            </div>
        );
    }
}
